import s from "react";
import l from "./storyblok-component.mjs";
import { BlockTypes as n, richTextResolver as c } from "./storyblok-js.mjs";
function i(e) {
  var t, o;
  const r = (t = e == null ? void 0 : e.attrs) == null ? void 0 : t.body;
  return s.createElement(l, {
    blok: Array.isArray(r) ? r[0] : void 0,
    key: (o = e.attrs) == null ? void 0 : o.id
  });
}
function p(e) {
  const r = {
    renderFn: s.createElement,
    resolvers: {
      [n.COMPONENT]: i,
      ...e.resolvers
    },
    keyedResolvers: !0
  };
  return c(r);
}
export {
  i as componentResolver,
  p as useStoryblokRichTextResolver
};
